import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stats: {
    totalProjects: 0,
    totalAffiliatesContacted: 0,
    totalAffiliates: 0,
    newAffiliatesAdded: 0
  },
  recentlyContactedAffiliates: [
    {
      id: 1,
      name: 'Sarah Chen',
      email: 'sarah@techblog.com',
      country: 'US',
      status: 'responded',
      lastContact: '2 hours ago',
      avatar: 'SC'
    },
    {
      id: 2,
      name: 'Mark Johnson',
      email: 'mark@deals.ca',
      country: 'CA',
      status: 'pending',
      lastContact: '1 day ago',
      avatar: 'MJ'
    }
  ],
  chartData: [
    { month: 'Jan', gains: 45, losses: 12, net: 33 },
    { month: 'Feb', gains: 32, losses: 18, net: 14 },
    { month: 'Mar', gains: 68, losses: 15, net: 53 },
    { month: 'Apr', gains: 78, losses: 22, net: 56 },
    { month: 'May', gains: 56, losses: 28, net: 28 },
    { month: 'Jun', gains: 89, losses: 11, net: 78 }
  ],
  hoveredMonth: null
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateStats: (state, action) => {
      state.stats = { ...state.stats, ...action.payload };
    },
    setHoveredMonth: (state, action) => {
      state.hoveredMonth = action.payload;
    },
    addRecentContact: (state, action) => {
      state.recentlyContactedAffiliates.unshift(action.payload);
    }
  }
});

export const { updateStats, setHoveredMonth, addRecentContact } = dashboardSlice.actions;
export default dashboardSlice.reducer;